export const SUB_TITLE = 'Choose 1';
export const TITLE = 'Song Genre';
